import { useLocation } from '@tanstack/react-router';
import { ungzip } from 'pako';
import { lt } from '@mews/framework';
import { Card, Container, Stack, Typography } from '@optimus-web/core';
import { DocumentsTable } from './documentsTable/DocumentsTable';
import { DocumentsTableContextProvider } from './documentsTable/DocumentsTableContext';

const decompressString = (value: string) => {
    const compressedBuffer = Buffer.from(value, 'base64');
    return ungzip(compressedBuffer, { to: 'string' });
};

export const TabContent = ({ groupId }: { groupId?: string }) => {
    const location = useLocation();
    const reservationIds =
        location.search.reservationIds != null
            ? decompressString(location.search.reservationIds).slice(1).split(',')
            : null;

    if (groupId == null) {
        throw new Error('There is no groupId');
    }

    return (
        <Container padding="100">
            <Stack vertical spacing="300">
                <Typography textStyle="titleLargeStrong" as="h2">
                    {lt('ContractsReservationTabContentTitle')}
                </Typography>
                <Card padding="200">
                    <Stack vertical spacing="400">
                        <Typography textStyle="titleMedium" as="h2">
                            {lt('ContractsTabSelectedReservationsLabel')}
                        </Typography>
                        {reservationIds != null &&
                            [...reservationIds].map((id) => (
                                <DocumentsTableContextProvider key={id} reservationId={id} groupId={groupId}>
                                    <DocumentsTable />
                                </DocumentsTableContextProvider>
                            ))}
                    </Stack>
                </Card>
            </Stack>
        </Container>
    );
};
